module.exports = __webpack_public_path__ + "static/media/tower-mania.b8f472e8.jpg";